<template>
  <div class="signup-widget">
        <validation-observer ref="observer" v-slot="{ handleSubmit }">
            <b-form name="signup-form" method="post" @submit.prevent="handleSubmit(onSubmit)">
                <b-row>

                    <b-col sm="5">
                        <validation-provider
                            rules="required|email"
                            v-slot="validationContext">
                            <b-form-input
                                id="email"
                                type="email"
                                v-model="email"
                                :placeholder="emailPlaceholder"
                                :class="inputsClass"
                                :state="getValidationState(validationContext)"
                            ></b-form-input>
                            <span>{{ validationContext[0] }}</span>
                        </validation-provider>
                    </b-col>

                    <b-col sm="3">
                        <validation-provider
                            rules="required|numeric"
                            v-slot="validationContext">
                            <b-form-input
                                id="postalCode"
                                type="text"
                                v-model="postalCode"
                                :placeholder="postalCodePlaceholder"
                                :class="inputsClass"
                                :state="getValidationState(validationContext)"
                            ></b-form-input>
                            <span>{{ validationContext[0] }}</span>
                        </validation-provider>
                    </b-col>

                    <b-col sm="4" class="center-block">
                        <b-button type="submit"
                            variant="primary"
                            class="btn-signup"
                            :class="buttonClass"
                            :disabled="sending||sent"
                            v-bind:style="{ 'background-color': buttonBgColor, 'color': buttonColor }"
                        >
                            {{ buttonText }}
                        </b-button>
                    </b-col>

                </b-row>

                <b-row>
                  <b-col cols="8" class="smalltext gdprConsent">
                    <validation-provider
                        :rules="{ required: { allowFalse: false } }"
                        v-slot="validationContext"
                    >
                      <b-form-checkbox
                          id="tos-checkbox"
                          v-model="gdprConsent"
                          name="tos-checkbox"
                          value="true"
                          unchecked-value="false"
                          :state="getValidationState(validationContext)"
                      >
                        By submitting your address you agree with Rexplorer’s <a href="https://www.rexplorer.ee/tos" target="_blank">terms of service</a> and <a href="https://www.rexplorer.ee/privacy" target="_blank">privacy policy</a>. We could also send you some marketing information about our digital platform but you can unsubscribe any time.
                      </b-form-checkbox>
                    </validation-provider>
                  </b-col>
                    <b-col cols="4">
                        <p v-if="showPoweredByText" class="copy smalltext center-block">powered by <a href="https://rexplorer.ee" target="_blank">Rexplorer⚡️</a></p>
                    </b-col>
                </b-row>

            </b-form>
        </validation-observer>
  </div>
</template>

<script>
import { BForm, BRow, BCol, BFormInput, BButton, BFormCheckbox } from 'bootstrap-vue'
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate';
import { required, numeric, email } from 'vee-validate/dist/rules';
import axios from 'axios';

extend('required', required);
extend('numeric', numeric);
extend('email', email);

export default {

    props: {
        customerId: String,

        buttonText: {
            type: String,
            default() {
                return 'Avastama!'
            }
        },

        inputsClass: String,

        buttonClass: String,

        buttonColor: {
            type: String,
            default() {
                return '#FFF'
            }
        },

        buttonBgColor: {
            type: String,
            default() {
                return '#D65D2B'
            }
        },

        emailPlaceholder: {
            type: String,
            default() {
                return 'E-mail'
            }
        },

        postalCodePlaceholder: {
            type: String,
            default() {
                return 'Postiindeks'
            }
        },

        showPoweredByText: {
            type: Boolean,
            default: true
        }
    },

    components: {
      BForm,
      BRow,
      BCol,
      BFormInput,
      BButton,
      ValidationProvider,
      ValidationObserver,
      BFormCheckbox
    },

    directives: {
        'b-form': BForm,
        'b-row': BRow,
        'b-col': BCol,
        'b-form-input': BFormInput,
        'b-form-checkbox': BFormCheckbox,
        'b-button': BButton,
    },

    methods: {
      getValidationState({ dirty, validated, valid = null }) {
          return dirty || validated ? valid : null;
      },
      onSubmit: function() {
        this.sending = true;
        const requestBody = {
          email: this.email,
          postalCode: this.postalCode,
          customerId: this.customerId,
          gdprConsent: new Date().toISOString()
        };
        axios.post('https://kdk4isiri1.execute-api.eu-central-1.amazonaws.com/prod/community', requestBody)
          .then(() => {
              this.sending = false;
              this.sent = true;
              window.location.href = `https://rexplorer.ee/community?postalCode=${this.postalCode}&email=${this.email}`
          })
          .catch((error) => {
              this.sending = false;
              console.error(error)
          })
        },
    },

    data() {
        return {
            email: '',
            postalCode: '',
            sending: false,
            sent: false,
            gdprConsent: []
        }
    },

}
</script>

<style scoped>
@import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
@import '../../node_modules/bootstrap-vue/dist/bootstrap-vue.min.css';

.signup-widget {
    max-width: 660px;
}

.signup-widget input {
    margin-bottom: 10px;
}

.copy a {
    color: #7BC8E7;
}

.gdprConsent {
  color: #000 !important;
}

.smalltext {
    font-size: 12px;
}

.center-block {
   text-align: center;
}

.btn-signup {
    margin-bottom: 5px;
    color: #fff;
    font-weight: bold;
    border: none;
    width: inherit;
}
</style>
